import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingBag, Menu } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '../ui/sheet';
import CartDrawer from '../Cart/CartDrawer';

const Header = () => {
  const { cartCount, setIsCartOpen } = useCart();
  const location = useLocation();

  const navLinks = [
    { href: '/', label: 'Accueil' },
    { href: '/products', label: 'Boutique' },
    { href: '/#about', label: 'Notre Histoire' },
    { href: '/#contact', label: 'Contact' },
  ];

  const isActive = (href) => {
    if (href === '/') return location.pathname === '/';
    return location.pathname.startsWith(href.split('#')[0]);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass" data-testid="header">
      <div className="container-custom">
        <div className="flex items-center justify-between h-20">
          
          {/* Menu Hamburger - Left */}
          <Sheet>
            <SheetTrigger asChild>
              <button
                data-testid="menu-btn"
                className="p-2 flex flex-col justify-center items-center gap-1.5"
              >
                <span className="block w-6 h-0.5 bg-text-primary"></span>
                <span className="block w-6 h-0.5 bg-text-primary"></span>
                <span className="block w-6 h-0.5 bg-text-primary"></span>
              </button>
            </SheetTrigger>
            <SheetContent side="left" className="w-80 bg-white border-r border-border">
              <SheetHeader>
                <SheetTitle className="font-serif text-2xl text-text-primary text-left">
                  Menu
                </SheetTitle>
              </SheetHeader>
              <nav className="flex flex-col mt-8 space-y-6">
                {navLinks.map((link) => (
                  <Link
                    key={link.href}
                    to={link.href}
                    data-testid={`menu-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                    className={`text-lg uppercase tracking-widest font-medium transition-colors ${
                      isActive(link.href) ? 'text-accent' : 'text-text-primary hover:text-accent'
                    }`}
                  >
                    {link.label}
                  </Link>
                ))}
              </nav>
            </SheetContent>
          </Sheet>

          {/* Logo - Center */}
          <Link 
            to="/" 
            className="absolute left-1/2 transform -translate-x-1/2"
            data-testid="logo-link"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_beauty-essence-15/artifacts/eqbnhryg_Logo%20Secret%20Musc.PNG" 
              alt="Secret Musc" 
              className="h-10 md:h-12 w-auto object-contain"
            />
          </Link>

          {/* Cart - Right */}
          <Sheet>
            <SheetTrigger asChild>
              <button
                data-testid="cart-btn"
                className="relative p-2"
                onClick={() => setIsCartOpen(true)}
              >
                <ShoppingBag className="w-6 h-6 text-text-primary" />
                {cartCount > 0 && (
                  <span className="cart-badge" data-testid="cart-count">
                    {cartCount}
                  </span>
                )}
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="w-full sm:max-w-lg bg-white border-l border-border">
              <SheetHeader>
                <SheetTitle className="font-serif text-2xl text-text-primary">
                  Votre Panier
                </SheetTitle>
              </SheetHeader>
              <CartDrawer />
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Header;
